<template>
  <div id="poster-dashboard" class="scroll-body">
    <pui-row class="poster-dasbhoard-row">
      <poster-dashboard-welcome-widget cols="12"></poster-dashboard-welcome-widget>
    </pui-row>

    <pui-row class="poster-dasbhoard-row">
      <poster-dashboard-shortcut
        v-permission="Permissions.QUICK"
        cols="6"
        lg="4"
        class="cart-shortcut"
      >
        <template #title>{{ $t('poster.dashboard.creation.title') }}</template>
        <template #subtitle>{{ $t('poster.dashboard.creation.subtitle') }}</template>
        <template #image>
          <div class="cart-icon-container">
            <!-- mdi-pencil-ruler -->
            <svg class="cart-icon" viewBox="0 0 24 24">
              <path
                d="M3 17.25V21H6.75L17.81 9.93L14.06 6.18L3 17.25M22.61 18.36L18.36 22.61L13.16 17.41L14.93 15.64L15.93 16.64L18.4 14.16L19.82 15.58L18.36 17L19.42 18L20.84 16.6L22.61 18.36M6.61 10.83L1.39 5.64L5.64 1.39L7.4 3.16L4.93 5.64L6 6.7L8.46 4.22L9.88 5.64L8.46 7.05L9.46 8.05L6.61 10.83M20.71 7C21.1 6.61 21.1 6 20.71 5.59L18.37 3.29C18 2.9 17.35 2.9 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7Z"
              />
            </svg>
            <div class="cart-count">{{ posterCart.length }}</div>
            <span class="cart-count-subtitle">{{
              $tc('poster.dashboard.creation.count_subtitle', posterCart.length)
            }}</span>
          </div>
        </template>
        <template #button>
          <router-link :to="{ name: 'posterCreation' }">
            <pui-button
              id="dash-btn-go-to-creation"
              v-track:click="Tracking.DASHBOARD_GO_TO_CREATION"
              variant="primary"
            >
              {{ $t('poster.dashboard.creation.go_to_creation') }}
            </pui-button>
          </router-link>
        </template>
      </poster-dashboard-shortcut>

      <poster-dashboard-shortcut v-permission="Permissions.QUICK" cols="6" lg="4">
        <template #title>{{ $t('poster.dashboard.batchCreation.title') }}</template>
        <template #subtitle>{{ $t('poster.dashboard.batchCreation.subtitle') }}</template>
        <template #button>
          <router-link :to="{ name: 'posterBatchCreation' }">
            <pui-button
              id="dash-btn-go-to-batch-creation"
              v-track:click="Tracking.DASHBOARD_GO_TO_BATCH_CREATION"
              variant="primary"
            >
              {{ $t('poster.dashboard.batchCreation.go_to_creation') }}
            </pui-button>
          </router-link>
        </template>
        <template #image>
          <img :src="imgSuzanneBatchCreation" />
        </template>
      </poster-dashboard-shortcut>

      <poster-dashboard-shortcut
        v-permission="Permissions.LOGS"
        icon="mdi-file-outline"
        cols="6"
        lg="4"
      >
        <template #title>{{ $t('poster.dashboard.my_demands.title') }}</template>
        <template #subtitle>{{ $t('poster.dashboard.my_demands.subtitle') }}</template>
        <template #button>
          <router-link :to="{ name: 'posterDemands' }" :event="''">
            <pui-button
              id="dash-btn-go-to-demands"
              v-track:click="Tracking.DASHBOARD_MY_DEMANDS"
              @click="navigateToMyDemands"
              variant="primary"
            >
              {{ $t('poster.dashboard.my_demands.go_to_my_demands') }}
            </pui-button>
          </router-link>
        </template>
        <template #image>
          <img :src="imgSuzanneDemands" />
        </template>
      </poster-dashboard-shortcut>
    </pui-row>

    <pui-row>
      <pui-demands-synthesis cols="12" />
    </pui-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import store from '../../../core/store';
import { FilterAlias } from '../constants';
import ConstantsMixin from '../mixins/ConstantsMixin';
import { getPosterService } from '../services';
import imgSuzanneBatchCreation from '../static/img/suzanne-batch-creation.svg';
import imgSuzanneDemands from '../static/img/suzanne-demands.jpg';
import {
  CLEAR_FILTERS,
  NAMESPACE as POSTER_NAMESPACE,
  SET_FILTER,
  SET_SELECTED_SIGNAGES,
} from '../store/modules/poster';

export default {
  mixins: [ConstantsMixin],
  data() {
    return {
      imgSuzanneDemands,
      imgSuzanneBatchCreation,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    posterCart: {
      get() {
        return getPosterService('cartState').get();
      },
      set(nextSignageItems) {
        getPosterService('cartState').set(nextSignageItems);
      },
    },
  },
  methods: {
    /**
     * Navigate to signage listing with user filter.
     */
    navigateToMyDemands() {
      // Clear filters and selection
      store.commit(`${POSTER_NAMESPACE}/${CLEAR_FILTERS}`);
      store.commit(`${POSTER_NAMESPACE}/${SET_SELECTED_SIGNAGES}`, []);
      store.commit(`${POSTER_NAMESPACE}/${SET_FILTER}`, {
        name: FilterAlias.USER_DISPLAY_NAME,
        value: this.user.displayName,
        operator: 'in',
      });
      this.$router.push({ name: 'posterDemands' });
    },
  },
};
</script>
